<template>
  <form action="" class="md:min-w-[500px] p-10 md:p-12">
    <div class="modal-card">
      <header class="modal-card-head mb-4">
        <p class="modal-card-title font-bold text-xl">Welcome to INFLUME!</p>
          <!-- <o-icon
            clickable
            native-type="button"
            icon="times"
            @click.native="$emit('close')"
          /> -->
      </header>
      <section class="modal-card-body">
        <o-field
          label="Name"
          :message="messages.userName"
          :variant="messages.userName ? 'danger' : ''">
          <o-input
            placeholder="Your name"
            v-model="userName">
          </o-input>
        </o-field>
        <o-field
          label="Subject"
          :message="messages.role"
          :variant="messages.role ? 'danger' : ''">
          <o-select
            v-model="role"
            placeholder="Select your role">
            <option :value="ROLE.Business">Business</option>
            <option :value="ROLE.Influencer">Influencer</option>
          </o-select>
        </o-field>
        <o-field
          label="Email"
          :message="messages.email"
          :variant="messages.email ? 'danger' : ''">
          <o-input
            type="email"
            v-model="email"
            placeholder="Your email"
            class="test">
          </o-input>
        </o-field>
        <o-field
          label="Password"
          :message="messages.password"
          :variant="messages.password ? 'danger' : ''">
          <o-input
            type="password"
            v-model="password"
            password-reveal
            placeholder="Your password">
          </o-input>
        </o-field>
        </section>
      <footer class="modal-card-foot mt-6">
        <o-button
          @click="signUp"
          variant="primary"
          class="w-full rounded-lg py-6 shadow-md">
          Sign Up
        </o-button>
        <o-button type="button" variant="cancel" @click="$emit('close')" class="mt-4 w-full rounded-lg py-6 shadow-md">Close</o-button>
        <div class="mt-5">
          Already have an account?
          <a href="#" class="font-medium ml-2" @click="showLoginModel">Login</a>
        </div>
      </footer>
    </div>
  </form>
</template>

<script>
import { ROLE } from '@/data/default'
import { EmailRegex } from '@/utils/regex'
import LoginForm from '@/components/LoginForm.vue'

export default {
  props: {
    roleProp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ROLE,
      userName: '',
      email: '',
      password: '',
      role: '',
      messages: {},
    }
  },
  watch: {
    roleProp: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) this.role = newVal
      },
    },
    userName() {
      this.checkNameValid()
    },
    email() {
      this.checkEmailValid()
    },
    password() {
      this.checkPasswordValid()
    },
    role() {
      this.checkRoleValid()
    },
  },
  methods: {
    showLoginModel() {
      this.$emit('close')
      this.$oruga.modal.open({
        component: LoginForm,
        trapFocus: true,
        contentClass: 'rounded-[2.5rem]'
      })
    },
    checkNameValid() {
      if (this.userName === '') this.messages.userName = 'userName is required!'
      else this.messages.userName = ''
    },
    checkEmailValid() {
      if (this.email === '') {
        this.messages.email = 'Email is required!'
        return
      } else {
        // eslint-disable-next-line no-useless-escape
        if (!EmailRegex.test(this.email)) this.messages.email = 'Invalid Email Address!'
        else this.messages.email = ''
      }
    },
    checkPasswordValid() {
      if (this.password === '') this.messages.password = 'Password is required!'
      else this.messages.password = ''
    },
    checkRoleValid() {
      if (this.role === '') this.messages.role = 'Role is required!'
      else this.messages.role = ''
    },
    getIfFormValid() {
      this.messages = {}
      this.checkNameValid()
      this.checkEmailValid()
      this.checkPasswordValid()
      this.checkRoleValid()
      this.messages = Object.assign({}, { ...this.messages })
      return Object.keys(this.messages).length === 0
    },
    signUp() {
      if (this.getIfFormValid() && this.loginRole) {
        console.log('Sign up success')
      }
    },
  },
}
</script>